import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { allMovies, sortMovies } from '@/utils/movie';

const latest = sortMovies(allMovies, 'updated').slice(0, 8);

export default function LatestMovies() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-950">
      <div className="flex items-end justify-between gap-4 mb-8 md:mb-10">
        <div>
          <span className="text-xs font-display tracking-[0.3em] text-primary-400">LATEST</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-black text-foreground-50">
            最新电影推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-400">精选近期热映与高分剧情佳作，点击卡片查看详情</p>
        </div>
        <Link
          to="/movie-category"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {latest.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>

      <div className="mt-8 sm:hidden">
        <Link
          to="/movie-category"
          className="flex items-center justify-center gap-1 w-full py-3 rounded-md bg-background-800/70 border border-background-700 text-sm text-foreground-100 cursor-pointer"
        >
          查看全部影片
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}